import { SanityRawContent } from "../model/common";

export function textFromBlock(block: any): string {
  const text =
    block &&
    block.children
      .filter((child: any) => child._type === "span")
      .map((span: any) => span.text)
      .join("");
  return text;
}

export const textFromFirstBlockNoFallback = (blocks: SanityRawContent) => {
  const block = (Array.isArray(blocks) ? blocks : []).find(
    (b: SanityRawContent) => b._type === "block"
  );
  return textFromBlock(block);
};

export function blockId(block: any): string | undefined {
  // We pull up these marks to the block.
  if (!block.markDefs) {
    return;
  }
  const namedAnchor = block.markDefs.filter(
    (m: any) => m._type === "namedAnchor"
  )[0];
  if (!namedAnchor) {
    return;
  }
  const marks = block.children.map((child: any) => child.marks).flat();
  // In some cases there are orphaned markDefs.
  // Check that the markDef _key is included in the block children marks.
  if (marks.includes(namedAnchor._key)) {
    return namedAnchor.name;
  }
}

export function linkFragmentFromText(block: any): string {
  // We pull up these marks to the block.
  const id = blockId(block);
  if (id) {
    return id;
  }

  // Since HTML 5 only space characters are invalid. \s covers unicode too.
  return textFromBlock(block)
    .trim()
    .replace(/\s+/g, "-")
    .toLowerCase();
}

export interface BlockTextChunk {
  title: string;
  id: string;
  content: SanityRawContent;
}

export const splitByH2 = (
  content: SanityRawContent,
  includeH2s: boolean = false
): BlockTextChunk[] =>
  (content || []).reduce(
    (sections: BlockTextChunk[], currentBlock: SanityRawContent) => {
      const isH2 = currentBlock.style === "h2";
      if (isH2) {
        sections.push({
          title: textFromBlock(currentBlock),
          id: currentBlock._key,
          content: includeH2s ? [currentBlock] : []
        });
      } else {
        if (sections.length) {
          const lastChildContent = sections[sections.length - 1].content;
          lastChildContent.push(currentBlock);
        }
      }
      return sections;
    },
    []
  );
